import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TopStories from "./components/TopStories";
import Categories from "./components/Categories";
import EventFeed from "./components/EventFeed";
import RankBoard from "./components/RankBoard";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";
import FloatingBar from "./components/FloatingBar";

export default function Home() {
  const [activeKey, setActiveKey] = useState("all");

  const jumpToFeed = (key: string) => {
    setActiveKey(key);
    document.getElementById("feed")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <TopStories />
        <Categories onSelect={jumpToFeed} />
        <EventFeed activeKey={activeKey} onFilterChange={setActiveKey} />
        <RankBoard />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />
      <FloatingBar />
    </div>
  );
}